import React, { useEffect } from "react"

export default function FullWidthImageCarouselItem({ image, position }) {
  useEffect(() => {
    const marqueeContainer = document.querySelector(".rfm-marquee-container")

    if (marqueeContainer && marqueeContainer.getAttribute("aria-hidden") !== "true") {
      marqueeContainer.setAttribute("tabindex", "-1")
      marqueeContainer.setAttribute("aria-hidden", "true")
    }
  }, [])

  return (
    <div className={`full-width-image-carousel-item pos-${position ? position : "center"}`}>
      <img alt="" aria-hidden="true" data-epi-property="BackgroundImage" src={image}></img>
    </div>
  )
}
